const payrollDate = [
  { label: "A Specific Date", value: "SET_DATE_MOVE_BACK" },
  { label: "First Working Day", value: "FIRST_WORKING_DAY" },
  { label: "Last Working Day", value: "LAST_WORKING_DAY" }
]

export default payrollDate